import { render, staticRenderFns } from "./sale-order-type-select.vue?vue&type=template&id=15fafb3c&scoped=true&"
import script from "./sale-order-type-select.vue?vue&type=script&lang=js&"
export * from "./sale-order-type-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fafb3c",
  null
  
)

export default component.exports